// `*_INITIAL_SORT_STATUS` and `*_INITIAL_FILTER_STATUS`es are constants
// that store the initial state of the sorters for pages
// containing a list view of items
const FEEDBACK_INITIAL_SORT_STATUS: NotNullableSortStatusT = {
  sortBy: 'date',
  orderStatus: 'desc',
};
const COMPANY_INITIAL_SORT_STATUS: NotNullableSortStatusT = {
  sortBy: 'name',
  orderStatus: 'asc',
};
const COMPANY_INITIAL_FILTER_STATUS: FilterQueryFormatT[] = [];
const CUSTOMER_INITIAL_SORT_STATUS: NotNullableSortStatusT = {
  sortBy: 'name',
  orderStatus: 'asc',
};
const CUSTOMER_INITIAL_FILTER_STATUS: FilterQueryFormatT[] = [];

// `*_FILTER_KEY_MAP`s are a mapper for converting columnKey
// to filter key name used in the backend

export {
  COMPANY_INITIAL_FILTER_STATUS,
  COMPANY_INITIAL_SORT_STATUS,
  CUSTOMER_INITIAL_FILTER_STATUS,
  CUSTOMER_INITIAL_SORT_STATUS,
  FEEDBACK_INITIAL_SORT_STATUS,
};
